import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { toast } from "react-toastify";

import { getUserProfile } from "store/reducers/authSlice";

const useProfileHook = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.userData);

  const [isLoading, setLoading] = useState(false);
  const [userProfile, setUserProfile] = useState(null);

  async function fetchUserProfile() {
    try {
      setLoading(true);
      await dispatch(getUserProfile());
    } catch (error) {
      // console.log({ error });
      // TODO : Add this once APIs are avaialble on UAT
      // toast.error(
      //   `${error?.response?.data?.message || 'Something Went Wrong!'}`
      // );
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchUserProfile();
  }, []);

  useEffect(() => {
    if (user) {
      setUserProfile(user);
    } else {
      setUserProfile(null);
    }
  }, [user]);

  return {
    isLoading,
    userProfile,
  };
};

export default useProfileHook;
